import { DATA_API_URL } from '../constants/api.constants';
import { fetchDataWithFetch } from './fetchBase';

type FetchDataApiOptions = RequestInit & {
  data?: unknown;
  responseType?: 'json' | 'blob';
};

export function fetchDataApi<T>(
  url: string,
  options: FetchDataApiOptions = {}
): Promise<T> {
  return fetchDataWithFetch<T>(url, { ...options, apiBaseUrl: DATA_API_URL });
}
